/**
 * Expose jQuery globally for legacy scripts (drentsemusea-maps, fix_calendar)
 * that expect window.$ / window.jQuery. Must be imported first in entry points.
 */
import $ from 'jquery';
if (typeof window !== 'undefined') {
  window.$ = window.jQuery = $;
}
